import React from 'react';

const LoadingSpinner = () => (
  <div>
    <i className="fa fa-refresh fa-spin fa-fw" /> Performing API Invocation...
  </div>
);

export default LoadingSpinner;